const itemMovementType = {
  Adjustment: 'Ajustement',
  BulkPackaging: 'Empaquetage de vrac',
  CancelledReception: 'Réception annulée',
  CancelledShipment: 'Expédition annulée',
  ContainerTransfer: 'Conteneur transféré',
  Merge: 'Fusion',
  MissingItemResolution: "Résolution d'item manquant",
  Move: 'Déplacement',
  OrderTransfer: 'Transfert',
  ReceptionByBarge: 'Réception par barge',
  ReceptionByContainer: "Réception à partir d'un conteneur",
  ReceptionByOther: 'Réception par autre',
  ReceptionByRailcar: 'Réception par wagon',
  ReceptionByTruck: 'Réception par camion',
  ReceptionByVessel: 'Réception par navire',
  Seal: 'Scellé',
  Split: 'Scindage',
  ShipmentByBarge: 'Expédition par barge',
  ShipmentByOther: 'Expédition par autre',
  ShipmentByRailcar: 'Expédition par wagon',
  ShipmentByTruck: 'Expédition par camion',
  ShipmentByVessel: 'Expédition par navire',
  Stuff: 'Empotage',
  StuffForTransfer: 'Empotage pour transfert',
  Transfer: 'Transfert',
  TransferredFromTC1: 'Transfert de TC1',
  Transform: 'Transformation',
  Unseal: 'Descellé',
  Unstuff: 'Dépotage',
  UnstuffForTransfer: 'Vidage pour transfert',
};

export default itemMovementType;
